@if (brandId && !messagingService.hasMessagingNumber() && !messagingService.getNumbersInProgress && processingNumbers.length === 0) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <div class="no-messages-container" style="text-align: center">
              <mat-icon class="icon-40">perm_phone_msg</mat-icon>
              <h2>You haven't added any Basic SMS numbers</h2>
              <p>You must enable numbers you'd like to use for Basic SMS.</p>
              <span
                *ngIf="!hasPhoneNumbersEditRight"> Contact your company administrator to setup messaging number.</span>
              <div *ngIf="hasPhoneNumbersEditRight">
                <button mat-flat-button color="primary" (click)="addNewSmsNumber()">
                  <span class="center-text">Add New Phone Number</span>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}

@if (brandId && !messagingService.hasMessagingNumber() && !messagingService.getNumbersInProgress && processingNumbers.length > 0) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <div class="no-messages-container" style="text-align: center">
              <mat-icon class="icon-40">perm_phone_msg</mat-icon>
              <h2>Activating SMS service is progress</h2>
              <p>SMS service activation could take up to 12h.</p>
              <div *ngFor="let number of processingNumbers" fxLayout="row" fxLayoutAlign="center center"
                   fxLayoutGap="5px">
                <span style="font-weight: bold">{{ number.number | phoneNumber }}</span>
                <span>Status: <span style="font-weight: bold">{{ number.smsServiceStatus }}</span></span>
              </div>
              <mat-progress-spinner style="margin: 50px auto" [strokeWidth]="3" mode="indeterminate"
                                    [diameter]="150"></mat-progress-spinner>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}

@if (!brandId && !messagingService.getNumbersInProgress) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <p-message severity="warn" icon="pi pi-exclamation-triangle">
              <span>
                You must register your brand and phone numbers with the Campaign Registry to continue using TeleGo SMS.
                This is a requirement by US Mobile Carriers (Verizon, T-Mobile, AT&T. etc.), so that they can cut back on Spam messages being sent to their customers.
                <br>
                <br>
                <a href="https://telego.com/solutions/request-sms-registration-form/" target="_blank">Request a SMS registration form here.</a>
                <br>
                <br>
                <a href="https://telego.zendesk.com/hc/en-us/articles/18090060421773-10-DLC-Registration-for-TeleGo-SMS"
                   target="_blank">Learn more here.</a>
              </span>
            </p-message>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}

<mat-drawer-container #mainContainer class="messaging-container"
                      *ngIf="messagingService.hasMessagingNumber() && brandId && !messagingService.getNumbersInProgress">
  <mat-drawer #threadsDrawer [mode]="sidenavMode" [opened]="showThreads">
    <div class="actions-container">
      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="isMobileView">
        <button mat-icon-button class="button-40" (click)="threadsDrawer.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-form-field class="selected-number-dropdown no-underline no-hint">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          [(ngModel)]="messagingService.selectedMessagingNumber"
          (valueChange)="onPhoneNumberValueChange($event)">
          <mat-select-trigger>
            <span class="selected-number-name">{{ messagingService.selectedMessagingNumber?.userName }}</span>
            <span class="selected-number light-text"
                  [class.warning]="!messagingService.selectedMessagingNumber?.campaignId">
              <span
                *ngIf="messagingService.selectedMessagingNumber?.campaignId">{{ messagingService.selectedMessagingNumber?.phoneNumber | phoneNumber }}</span>
               <app-explanation *ngIf="!messagingService.selectedMessagingNumber?.campaignId"
                                icon="priority_high"
                                label="{{messagingService.selectedMessagingNumber?.phoneNumber | phoneNumber}}"
               >
                <span>
                  This phone number is not 10DLC registered and may be blocked from sending messages.
                  <a class="btn-link" role="button" (click)="openSupportWidget()">Please contact us to register this number</a>.
                </span>
              </app-explanation>
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let option of messagingService.messagingNumbers" [value]="option"
                      (click)="onPhoneNumberClicked(option)"
                      style="line-height: 1; height: 4em" class="selected-number-popup">
            <span style="font-weight: 600;font-size: 16px;line-height: 20px;">
              {{ option.userName }}
            </span>
            <span style="font-weight: normal; font-size: 13px; line-height: 16px; padding-left: 0; display: block"
                  [matBadge]="option.badge"
                  [matBadgeHidden]="!option.badge || option.badge <= 0"
                  matBadgePosition="after"
                  matBadgeColor="warn">
              {{ option.phoneNumber | phoneNumber }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="hasEditAccess && messagingService.selectedMessagingNumber?.allowSend">
        <button type="button" class="compose-btn" mat-flat-button color="primary" (click)="onNewMessage($event)">
          <mat-icon>add_circle</mat-icon>
          <span>Compose A New Message</span>
        </button>
      </div>
    </div>

    <div class="threads-container">
      <app-phone-number-group #threadCmp
                              [selectedNumber]="routedPhoneNumber"
                              [selectedTheadKey]="routedThreadKey"
                              [hasContactsEditRight]="hasContactsEditRight"
                              [hasContactsModule]="hasContactsModule"
                              [defaultSortType]="smsThreadSortType"
                              (selectedThreadChangeEvent)="onSelectedThreadChanged($event)"
      ></app-phone-number-group>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <form class="messages-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <div class="messages-container" fxLayout="column" [ngClass]="{'is-mobile-view': isMobileView}">
        <div class="messages-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <button mat-icon-button class="button-40 rect-btn active-accent" type="button"
                  *ngIf="isMobileView" (click)="threadsDrawer.toggle()" fxFlexOrder="1">
            <mat-icon>menu_open</mat-icon>
          </button>
          <div fxLayout="row" fxLayoutAlign="start center"
               fxFlex fxFlex.xs="100" fxFlexOffset.xs="10px"
               fxLayoutGap="10px" fxFlexOrder="2" fxFlexOrder.xs="3">
            <label>To:</label>
            <app-thread-recipients class="messaging-recipients" formControlName="clientPhoneNumbers" fxFlex
                                   [disabled]="readOnlyPhone" placeholder="Enter phone number"></app-thread-recipients>
          </div>
          <button type="button" mat-icon-button color="warn" class="button-40 rect-btn active-warn" fxFlexOrder="3"
                  fxFlexOrder.xs="2"
                  title="Delete Conversation"
                  (click)="onDeleteClick()"
                  *ngIf="hasDeleteAccess && messagingService.selectedMessagingNumber?.allowSend && !!selectedGroup && !!selectedGroup?.groupKey">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="messages-holder" fxFlex>
          <app-messages-grid
            [selectedPhoneNumber]="routedPhoneNumber"
            [selectedThreadKey]="routedThreadKey"
          ></app-messages-grid>
        </div>
        @if ((messagesDatasource.loading$ | async) === false && !messagingService.getNumbersInProgress && selectedGroup) {
          <div class="messages-actions">
            @if (hasEditAccess && messagingService.selectedMessagingNumber?.allowSend && !selectedGroup?.broadcastId && !limitsReached) {
              <div class="messages-footer">
                <div class="messages-form">
                  <div class="actions-row" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"
                       [ngClass]="{'is-mobile-view': isMobileView}">
                    <mat-form-field appearance="outline" fxFlex class="message-text-field">
                  <textarea #textInput maxlength="2048"
                            matInput
                            [cdkTextareaAutosize]="true"
                            [cdkAutosizeMinRows]="1"
                            [cdkAutosizeMaxRows]="5"
                            formControlName="message"
                            (focus)="markUnreadMessages()"
                            (keypress)="msgKeyPress($event)" placeholder="Enter your message">
                  </textarea>
                    </mat-form-field>
                    <button type="submit" mat-icon-button class="button-40 rect-btn message-send-btn active"
                            color="primary"
                            matTooltip="Send Message">
                      @if (!submitting) {
                        <mat-icon>send</mat-icon>
                      } @else {
                        <mat-spinner diameter="24" strokeWidth="2"></mat-spinner>
                      }
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </form>
  </mat-drawer-content>
</mat-drawer-container>

